import React from 'react';
import {LogoIcon} from 'icons';

import './logo.scss';

const Logo = () => (
  <div className="logo">
    <LogoIcon />
    <div className="logo-title">
      <div className="logo-name">Fireswan</div>
      <div className="logo-beta">Beta</div>
    </div>
  </div>
);

export default Logo;
